<div id="relatorio-guias" class="container-fluid">
  <h3>Painel de Manifestos de Embarque</h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="filtros-header" [formGroup]="panelForm" (keyup.enter)="search()">
          <div class="header-filter-log">
            <div class="row" style="display: inherit;">

              <mat-form-field class="example-full-width">
                <mat-label>Nr Manifesto de Embarque</mat-label>
                <input #meId matInput somenteNumeros class="number" type="text" maxlength="9"
                  formControlName="manifestoEmbarqueId">
              </mat-form-field>

              <mat-form-field>
                <mat-label>Situação</mat-label>
                <mat-select formControlName="flgTipoSituacao" (selectionChange)="updateCardsFlags()">
                  <mat-option value="0">Todos</mat-option>
                  <mat-option selected value="1">Pendentes</mat-option>
                  <mat-option value="2">Baixados</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>De:</mat-label>
                <input matInput autocomplete="off" maskDate [matDatepicker]="dataInicial" formControlName="dataInicial">
                <mat-datepicker-toggle matSuffix [for]="dataInicial"></mat-datepicker-toggle>
                <mat-datepicker #dataInicial></mat-datepicker>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Até:</mat-label>
                <input matInput autocomplete="off" maskDate [matDatepicker]="dataFinal" formControlName="dataFinal">
                <mat-datepicker-toggle matSuffix [for]="dataFinal"></mat-datepicker-toggle>
                <mat-datepicker #dataFinal></mat-datepicker>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Código de Barras</mat-label>
                <input matInput autocomplete="off" formControlName="codigoBarras">
              </mat-form-field>

              <button mat-icon-button class="notification-button cursor-pointer-icon" (click)="clearFields()"
                matTooltip="Limpar Campos" [disabled]="isLoading">
                <mat-icon fontSet="fas" fontIcon="fa-eraser"></mat-icon>
              </button>

              <button mat-icon-button class="notification-button cursor-pointer-icon" (click)="search()"
                [disabled]="panelForm.invalid || isLoading" matTooltip="Pesquisar">
                <mat-icon fontSet="fas" fontIcon="fa-search"></mat-icon>
              </button>
            </div>
          </div>
        </form>
        <div class="d-flex justify-content-center">
          <ngx-charts-number-card [hidden]="!cards" [results]="cards" [view]="view" [scheme]="colorScheme" [cardColor]="cardColor"
            (select)="toggleCards($event)">
          </ngx-charts-number-card>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content class="no-padding">
      <div>
        <div class="table-responsive">
          <table mat-table [dataSource]="panelCollection">
            <ng-container matColumnDef="acao">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let item" width="90px">
                <div>
                  <button mat-icon-button [matMenuTriggerFor]="menu"
                    [disabled]="!item.dtBaixa && item.stProrrogSLA != 'Pendente'"
                    aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button (click)="solicitarAumento(item)" mat-menu-item color="primary"
                      [disabled]="!habilitarProrrogacao && !habilitarProrrogacaoPainelME">
                      <mat-icon fontSet="fas" fontIcon="fa-check"></mat-icon>
                      <span>Solicitar Prorrogação de SLA</span>
                    </button>
                  </mat-menu>
                </div>
                <!-- <div class="div" *ngIf="item.status == 'Pendente'"> -->
              </td>
            </ng-container>
            <ng-container matColumnDef="dtCriacao">
              <th mat-header-cell *matHeaderCellDef class="text-center">Data Criação</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.dtCriacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="filialOrigem">
              <th mat-header-cell *matHeaderCellDef class="text-center">Origem</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.filial }}</td>
            </ng-container>

            <ng-container matColumnDef="manifestoEmbarqueId">
              <th mat-header-cell *matHeaderCellDef class="text-center">Número</th>
              <td mat-cell (click)="openModalMEDetalhe(item)" *matCellDef="let item"
                class="text-center link cursor-pointer-icon">
                <a>{{ item.manifestoEmbarqueId}}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="agente">
              <th mat-header-cell *matHeaderCellDef class="text-center">Agente</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.agente }}</td>
            </ng-container>

            <ng-container matColumnDef="volume">
              <th mat-header-cell *matHeaderCellDef class="text-center">Volume</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.volume }} </td>
            </ng-container>

            <ng-container matColumnDef="valor">
              <th mat-header-cell *matHeaderCellDef class="text-center">Valor</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.valor | currency:'BRL'}}</td>
            </ng-container>

            <ng-container matColumnDef="motorista">
              <th mat-header-cell *matHeaderCellDef class="text-center">Motorista</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.motorista }}</td>
            </ng-container>

            <ng-container matColumnDef="placa">
              <th mat-header-cell *matHeaderCellDef class="text-center">Placa</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.placa }}</td>
            </ng-container>

            <ng-container matColumnDef="tipoSituacaoManifestoEmbarque">
              <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.tipoSituacaoManifestoEmbarque }}</td>
            </ng-container>

            <ng-container matColumnDef="dtBaixa">
              <th mat-header-cell *matHeaderCellDef class="text-center">Data da Baixa</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.dtBaixa | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="usuarioBaixa">
              <th mat-header-cell *matHeaderCellDef class="text-center">Baixado por</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.usuarioBaixa }}</td>
            </ng-container>

            <ng-container matColumnDef="dtVencRessalva">
              <th mat-header-cell *matHeaderCellDef class="text-center">Limite SLA</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.dtVencRessalva | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="qtdRessalvas">
              <th mat-header-cell *matHeaderCellDef class="text-center">Qtd Ressalvas</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.qtdRessalvas }}</td>
            </ng-container>

            <ng-container matColumnDef="stProrrogSLA">
              <th mat-header-cell *matHeaderCellDef class="text-center">St.Prorrog. SLA</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.stProrrogSLA }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <div *ngIf="!isLoading && panelCollection?.data?.length === 0"
          class="d-flex justify-content-center align-items-center" style="height: 100px;">
          Nenhum registro para o período!
        </div>
        <app-paginacao *ngIf="!isLoading && panelCollection?.data?.length != 0" [pageIndex]="paging?.index"
          [pageSize]="paging?.size" [length]="paging?.length" (page)="onPageChange($event)"
          [pageSizeOptions]="[5, 10, 50, 100]">
        </app-paginacao>
      </div>

    </mat-card-content>
  </mat-card>
</div>
